import React from "react";
import moment from 'moment';

import styles from "./DashboardViews.module.scss";

const QuestionFinalize = (props) => {
    const { task } = props;
    // const is_attested = (task.subtask_data && task.subtask_data.understood === "t" ? true : false) || false;
    // const requires_attest = (task.subtask_data && task.subtask_data.requires_attest === "t" ? true : false) || false;
    return (
        <div className={styles.question}>

            <div className={styles.title_holder}>
                <i className={`fal fa-check-circle ${styles.icon}`} />
                <h3>Task Finalized</h3>
                <p>You have submitted answer of the audit question.</p>
            </div>

            <div className={styles.task_holder}>

                <div>
                    <div>Question:</div>
                    <div>{task.task}</div>
                </div>

                <div>
                    <div>Answer:</div>
                    <div>{task.subtask_data.answer === "2" && 'Yes'}</div>
                    <div>{task.subtask_data.answer === "1" && 'No'}</div>
                    <div>{task.subtask_data.answer === "3" && 'Not Applicable'}</div>
                    <div>{task.subtask_data.answer === "4" && 'Not Applicable'}</div>
                </div>

                <div>
                    <div>Risk level:</div>
                    <div>{task.subtask_data.risk}</div>
                </div>

                <div>
                    <div>Notes:</div>
                    <div>{task.subtask_data.notes}</div>
                </div>

                <div>
                    <div>Requested date:</div>
                    <div>{task.assigned ? moment(task.assigned).format('MM/DD/YYYY') : ''}</div>
                </div>

                <div>
                    <div>Type:</div>
                    <div>Question</div>
                </div>

                {task.siteName && <div>
                    <div>Site:</div>
                    <div>{task.siteName}</div>
                </div>}

            </div>
        </div>
    );
}

export default QuestionFinalize;
